// @flow
import createIcon from 'mz-icons/utils/createIcon'

export default createIcon({
  iconName: 'general-cc',
  icon: [
    335,
    220,
    null,
    null,
    'M318 111H17V55h301V19H17v183h301v-91zM0 14.7C0 7.3 6.7 0 13.4 0h308.2c6.7 0 13.4 7.3 13.4 14.7v190.6c0 7.4-6.7 14.7-13.4 14.7H13.4C6 220 0 213.4 0 205.3V14.7zM218.3 129h66.8v19h-66.8v-19zm-50.8 0h33.9v19h-33.9v-19z',
  ],
})
